import { Button } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { RoutedLink } from "components/common/Link";
import { AppController } from "controllers/AppController";
import SessionController from "controllers/SessionController";
import AgentButton from "components/Agent/AgentButton";
import tauri from "lib/tauri";
import { Fragment } from "react";
import ClubMenu from "./ClubMenu";
import DesktopAppLink from "./DesktopAppLink";
import SettingsMenu from "./SettingsMenu";
import TopNavDivider from "./TopNavDivider";
import UserMenu from "./UserMenu";

const TopNav = () => {
  const sessionController = SessionController.use();
  const appController = AppController.use();
  const { currentClub, clubs } = appController.state;
  const { loginState } = sessionController.state;
  const showDesktopAppLink = !tauri.enabled;
  const showClubMenu = Boolean(currentClub) || clubs.length > 0;

  return (
    <div className="relative z-10 flex shrink-0 items-center self-center" role="navigation">
      {loginState === "signed-out" && (
        <RoutedLink to="/login">
          <span>Sign in</span>
        </RoutedLink>
      )}
      {sessionController.signedIn && !sessionController.isAnonymous && (
        <>
          {showClubMenu && (
            <Fragment key="topnav-club">
              <ClubMenu />
              <TopNavDivider />
            </Fragment>
          )}
          {showDesktopAppLink && (
            <Fragment key="topnav-desktop-app">
              <DesktopAppLink />
              <TopNavDivider />
            </Fragment>
          )}
          <AgentButton key="topnav-agent" />
          <TopNavDivider key="topnav-agent-divider" />
          <SettingsMenu key="topnav-settings-menu" />
          <TopNavDivider key="topnav-settings-divider" />
          <UserMenu key="topnav-user-menu" />
        </>
      )}
      {loginState === "unknown" && (
        <Button disabled spinner>
          Sign in
        </Button>
      )}
    </div>
  );
};

export default ApplicationView(TopNav);
